/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  string, func, number
} from 'prop-types';
import { Price } from '@thd-olt-component-react/price';
import { extend } from '@thd-nucleus/data-sources';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { AddTo, AddToListModel } from '@thd-olt-component-react/add-to';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { NonBuyableQuoteCenter } from '@thd-olt-component-react/non-buyable-quote-center';
import {
  ProductPod,
  PodSticker,
  ProductATC,
  ProductRating,
  ProductSample,
  ProductIdentifier, ProductBadge, ProductSponsored,
  ProductImage, PodSection, ProductCompare,
  ProductCustomOptions, PodSpacer
} from '@thd-olt-component-react/product-pod';

export const VendorCollectionPod = ({
  itemId,
  storeId,
  position
}) => {

  return (
    <ProductPod
      itemId={itemId}
      analyticsData={{
        parent: 'vendorcollection', position
      }}
      render={(pod) => (
        <>
          <PodSticker position="top-right">
            <PodSpacer padding={['TOP', 'RIGHT']}>
              <AddTo
                addToType="List"
                products={[
                  {
                    itemId: pod.itemId,
                    quantity: 1
                  }
                ]}
                list={{ showCount: true, showIconButton: true }}
              />
            </PodSpacer>
          </PodSticker>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
          />
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="inline"
                itemId={pod.itemId}
                brandTitleMaxLine={4}
                disableShopThisCollection
              />
            </PodSpacer>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductRating itemId={pod.itemId} />
            </PodSpacer>
            <PodSpacer minHeight="60px" padding={['TOP', 'BOTTOM']}>
              <Price
                itemId={pod.itemId}
                type="simple"
                storeId={storeId}
                displayEachUom={false}
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideForProductTypes={['HDQC']}
                hideFulfillment
                hideBadges
                hideShopThisCollection
                hideSponsored
              />
            </PodSpacer>
          </PodSection>
          <div>
            <PodSpacer>
              <NonBuyableQuoteCenter itemId={pod.itemId} />
            </PodSpacer>
            <ProductATC
              itemId={pod.itemId}
              outline
              ShowDisabledATC
              doNotShowChooseYourOptions
            />
          </div>
        </>
      )}
    />
  );
};

VendorCollectionPod.dataModel = extend(
  AddToListModel,
  ProductImage,
  Price,
  SuperSkuMiniSwatches,
  ProductATC,
  ProductRating,
  ProductCompare,
  ProductSample,
  ProductIdentifier,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  ProductCustomOptions,
  KeyProductFeatures,
  NonBuyableQuoteCenter
);

VendorCollectionPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  position: number.isRequired
};

VendorCollectionPod.defaultProps = {};

VendorCollectionPod.displayName = 'VendorCollectionPod';
